import React from 'react'
import { DialogOverlay, DialogOverlayActions, DialogOverlayFooter } from '@fs/zion-ui'
import ZionForm from '@fs/zion-form'
import CancelButton from './CancelButton'
import SubmitButton from './SubmitButton'

export default function DialogForm({
  headingText,
  overlay,
  close = () => overlay.close(),
  children,
  submitButtonText,
  methods,
  onSubmit,
  noFooter = false,
  ...props
}) {
  const {
    reset,
    formState: { isSubmitting },
  } = methods
  const actions = (
    <DialogOverlayActions>
      <CancelButton
        onClick={() => {
          close()
          reset()
        }}
      />
      <SubmitButton type="submit" disabled={isSubmitting} isSubmitting={isSubmitting}>
        {submitButtonText}
      </SubmitButton>
    </DialogOverlayActions>
  )
  return (
    <DialogOverlay
      title={headingText}
      {...overlay}
      close={close}
      as={ZionForm}
      methods={methods}
      onSubmit={onSubmit}
      {...props}
    >
      {children}
      {noFooter && actions}

      {!noFooter && <DialogOverlayFooter>{actions}</DialogOverlayFooter>}
    </DialogOverlay>
  )
}
